import { Component, OnInit, OnDestroy, ViewChild, HostListener } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LoginService } from 'src/app/managers/login.service';
import { BaseComponent } from 'src/app/common/components/base/base.component';
import { ClientConfigService } from 'src/app/common/services/client-config.service';
import { MatDialog, MatDrawer } from '@angular/material';
import { OutputDataService } from 'src/app/common/services/output-data.service';
import { Subscription } from 'rxjs';
import { ChannelItem } from 'src/app/models/channel_item';
import { FunctionsService } from 'src/app/common/services/functions.service';
import { DisplayModeActionType, displayModeReducer, SubscriptionDisplayModeActionType } from 'src/app/store/reducers';
import { Store, UnsubscribeCallback } from 'src/app/store/store';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent extends BaseComponent implements OnInit, OnDestroy {
  @ViewChild('drawer', { static: true }) drawer: MatDrawer;
  addedFavoriteChannelItem: ChannelItem;
  removedFavoriteChannelItem: ChannelItem;
  componentHeight: string;
  displayMode: DisplayModeActionType;
  subDisplayMode: SubscriptionDisplayModeActionType;
  private _onMenuOpenedSubscription: Subscription;
  private _onLogoutSubscription: Subscription;
  private _unsubscribeSubscriptionDisplayModeState: UnsubscribeCallback;
  private _unsubscribeDisplayModeState: UnsubscribeCallback;
  private _unsubscribeChannelState: UnsubscribeCallback;

  constructor(route: ActivatedRoute, loginManager: LoginService, clientConfig: ClientConfigService, dialog: MatDialog, private _outputDataService: OutputDataService,
              private _functionsService: FunctionsService, private _store: Store) {
    super(route, loginManager, clientConfig, dialog); 
    this.setComponentHeight();

    this._unsubscribeSubscriptionDisplayModeState = this._store.subscribeSubscriptionDisplayModeState(() => {
      this.subDisplayMode = this._store.getSubscriptionDisplayModeState();
    });

    this._unsubscribeDisplayModeState = this._store.subscribeDisplayModeState(() => {
      this.displayMode = this._store.getDisplayModeState();
    });

    this._unsubscribeChannelState = this._store.subscribeChannelState(() => {
      this.displayMode = this._store.getDisplayModeState();
    });
  }

  @HostListener('window:resize', ['$event'])
  getScreenSize(event?) {
    this.setComponentHeight();
  }

  ngOnInit() {
    super.ngOnInit();
    this._onMenuOpenedSubscription = this._outputDataService.onMenuOpened.subscribe(x => this.toggleMenu(x));

    this._onLogoutSubscription = this._outputDataService.onLogout.subscribe(() => {    
      this._store.dispatch(displayModeReducer, { type: DisplayModeActionType.Today });
      this.displayMode = this._store.getDisplayModeState();
    });

    this.dataSource = this.getLoggedinUser();
    this.displayMode = this._store.getDisplayModeState();
    this.subDisplayMode = this._store.getSubscriptionDisplayModeState();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    this._onMenuOpenedSubscription.unsubscribe();
    this._onLogoutSubscription.unsubscribe();
    this._unsubscribeSubscriptionDisplayModeState();
    this._unsubscribeChannelState();
    this._unsubscribeDisplayModeState();
  }
 
  favoriteItemAdded(channelItem) {
    this.addedFavoriteChannelItem = channelItem;
  }

  favoriteItemRemoved(channelItem) {
    this.removedFavoriteChannelItem = channelItem;
  }

  private toggleMenu(opened: boolean) {
    if (opened)
      this.drawer.open();
    else
      this.drawer.close();
  }

  private setComponentHeight() {
    let screenHeight: number = window.innerHeight;
    let screenWidth: number = window.innerWidth;
    this.componentHeight = screenHeight - this._functionsService.getSubtractionForAppHeight(this.isUserAdmin()) + 'px';
  }
}
